import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../../core/style/gstheme';
import TaxonomySelectorMenuItem from './TaxonomySelectorMenuItem';
import GS from '../../grafsync/grafsync';

const styles = theme => {
  return Object.assign({
    input: {
      width: '100%'
    },
    menuItem: {
      fontSize: theme.typography.bodyFontSize
    },
    dropDownIcon: {
      borderLeft: theme.palette.border.main
    }
  }, globalStyles);
};

const LabelledInput = withStyles(theme => ({
  root: {
    marginTop: theme.spacing(2.5),
    border: theme.palette.border.main,
    backgroundColor: 'white',
    fontSize: '14px',
    borderRadius: '4px',
    '&:focus': {
      borderRadius: 4,
      backgroundColor: 'white',
      border: theme.palette.border.main
    },
    '@media print': {
      display: 'none'
    }
  },
  input: {
    width: '242px',
    position: 'relative',
    fontSize: '14px',
    borderRadius: '4px',
    backgroundColor: 'white',
    padding: '9px 10px 9px 12px',
    '&:focus': {
      borderRadius: '4px',
      backgroundColor: 'white'
    },
  },
}))(InputBase);

class TaxonomySelector extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
      infoLoading: true,
      sortedTaxonomies: this.props.taxonomies
    };
  }

  handleChange = event => {
    this.setState({ selected: event.target.value });
    this.props.handleChange(event.target.value);
  };

  static getDerivedStateFromProps(props, state) {
    if (props.taxonomies.length !== state.sortedTaxonomies.length) {
      return {
        infoLoading: true
      };
    }
    return null;
  }

  componentDidUpdate() {
    if (this.state.infoLoading === true) {
      this.getData();
    }
  }

  componentDidMount() {
    this.getData();
  }

  getTaxomomyLabel = (scheme) => {
    const label = scheme.title && scheme.title[this.props.defaultLang]
      ?
      scheme.title[this.props.defaultLang]
      :
      scheme.title && scheme.title["und"] ?
        scheme.title && scheme.title["und"]
        :
        scheme.id;
    return label;
  };

  getData = () => {
    const sortedTaxonomies = [...this.props.taxonomies].sort((a, b) => {
      const aLabel = this.getTaxomomyLabel(GS.data(a, this.props.graph, false));
      const bLabel = this.getTaxomomyLabel(GS.data(b, this.props.graph, false));
      if (aLabel.toLowerCase() < bLabel.toLowerCase()) return - 1;
      return 1;
    });
    this.setState({ sortedTaxonomies, infoLoading: false });
  };

  render() {

    const { classes, autoFocus, disabled, graph, defaultLang, displayWorkflow } = this.props;
    const { selected, sortedTaxonomies } = this.state;

    return (
      <FormControl className={classes.input}>
        <InputLabel className={classes.formSelectorLabel}>Taxonomy</InputLabel>
        <Select
          data-test="scheme-selector"
          disabled={disabled}
          classes={{
            icon: classes.dropDownIcon
          }}
          className={classes.select}
          style={{ width: '100%', lineHeight: '1em' }}
          value={selected || ''}
          onChange={this.handleChange}
          IconComponent={ArrowIcon}
          displayEmpty={true}
          inputProps={{
            className: classes.input
          }}
          MenuProps={{
            "data-test": "scheme-selector-list",
            className: classes.menuItem
          }}
          input={<LabelledInput
            inputProps={{ "data-test": "selected-value" }}
            autoFocus={autoFocus} />}
        >
          <MenuItem
            data-test={"item-All"}
            className={classes.menuItem}
            value="All">
            <span style={{ width: '100%' }}>All</span>
          </MenuItem>
          {sortedTaxonomies.map(option =>
            <MenuItem
              data-test={"scheme-selector-item-" + option}
              className={classes.menuItem}
              key={option}
              value={option}>
              <span style={{ width: '100%' }}>
                <TaxonomySelectorMenuItem
                  displayWorkflow={displayWorkflow}
                  defaultLang={defaultLang}
                  key={option}
                  id={option}
                  graph={graph} />
              </span>
            </MenuItem>
          )}
        </Select>
      </FormControl>
    );
  }
}

TaxonomySelector.defaultProps = {
  autoFocus: false,
  taxonomies: [],
  disabled: false,
  selected: "All",
  displayWorkflow: false
};

TaxonomySelector.propTypes = {
  autoFocus: PropTypes.bool,
  displayWorkflow: PropTypes.bool,
  disabled: PropTypes.bool,
  selected: PropTypes.string,
  defaultLang: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  taxonomies: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(TaxonomySelector);